// POS v2.4 — selector de documento (FE/Recibo) + cobro por QR Bre-B (SnelPay)
import React, { useEffect, useRef, useState } from 'react';
import { posCaja, posAbrirCaja, posCerrarCaja, posVenta, getProductos, getConfiguracion,
  posCobroQR, posCobroQREstado, posBuscarClientes, posFormas, posConfig, posVerificarPin } from '../services/api';
import RibbonActions from '../components/RibbonActions';
import ClienteModal from '../components/ClienteModal';
import { useAuth } from '../context/AuthContext';

const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO');
// Precio base (sin IVA) de una línea: si el precio ya incluye IVA, lo quita.
const baseUnit = (it, incIva) => incIva ? (Number(it.precio_unitario) || 0) / (1 + (Number(it.iva_pct) || 0) / 100) : (Number(it.precio_unitario) || 0);
// Total de la línea (con IVA y descuento), coherente con el backend.
const lineaTotal = (it, incIva) => {
  const cant = Number(it.cantidad) || 0, desc = Number(it.descuento_pct) || 0, iva = Number(it.iva_pct) || 0;
  return baseUnit(it, incIva) * cant * (1 - desc / 100) * (1 + iva / 100);
};
const MEDIO_LBL = { efectivo: 'Efectivo', tarjeta: 'Tarjeta', qr: 'QR / Bre-B', otro: 'Otro' };
const formaDefault = (list) => list.find(f => f.tipo === 'efectivo') || list[0] || null;

// Abre una ventana con el tiquete (estilo rollo 58mm) y lanza la impresión.
function imprimirTiquete({ empresa, factura, items, medio, recibido, cambio, incIva }) {
  const esc = (x) => String(x ?? '').replace(/[<>&]/g, c => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]));
  const base = items.reduce((s, it) => s + baseUnit(it, incIva) * (Number(it.cantidad) || 0) * (1 - (Number(it.descuento_pct) || 0) / 100), 0);
  const iva = items.reduce((s, it) => s + baseUnit(it, incIva) * (Number(it.cantidad) || 0) * (1 - (Number(it.descuento_pct) || 0) / 100) * (Number(it.iva_pct) || 0) / 100, 0);
  const filas = items.map(it => `<tr><td colspan="2">${esc(it.descripcion)}${Number(it.descuento_pct) ? ` <small>(-${it.descuento_pct}%)</small>` : ''}</td></tr>
    <tr><td>${it.cantidad} x ${fmt(it.precio_unitario)}</td><td style="text-align:right">${fmt(lineaTotal(it, incIva))}</td></tr>`).join('');
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Tiquete ${esc(factura.numero)}</title>
    <style>@page{size:58mm auto;margin:3mm} body{width:58mm;font:11px/1.35 'Courier New',monospace;color:#000;margin:0}
    h1{font-size:13px;text-align:center;margin:0 0 2px} .c{text-align:center} table{width:100%;border-collapse:collapse}
    td{padding:1px 0;vertical-align:top} .hr{border-top:1px dashed #000;margin:4px 0} .tot{font-size:13px;font-weight:bold}</style></head>
    <body>
      <h1>${esc(empresa?.empresa_nombre || 'Mi Empresa')}</h1>
      ${empresa?.empresa_nit ? `<div class="c">NIT ${esc(empresa.empresa_nit)}</div>` : ''}
      ${empresa?.empresa_direccion ? `<div class="c">${esc(empresa.empresa_direccion)}</div>` : ''}
      <div class="hr"></div>
      <div>Documento: ${esc(factura.numero)}</div>
      <div>Fecha: ${new Date().toLocaleString('es-CO')}</div>
      <div class="hr"></div>
      <table>${filas}</table>
      <div class="hr"></div>
      <table>
        <tr><td>Subtotal</td><td style="text-align:right">${fmt(base)}</td></tr>
        <tr><td>IVA</td><td style="text-align:right">${fmt(iva)}</td></tr>
        <tr class="tot"><td>TOTAL</td><td style="text-align:right">${fmt(factura.total)}</td></tr>
        <tr><td>Pago</td><td style="text-align:right">${esc(MEDIO_LBL[medio] || medio)}</td></tr>
        ${medio === 'efectivo' && recibido != null ? `<tr><td>Recibido</td><td style="text-align:right">${fmt(recibido)}</td></tr>
        <tr><td>Cambio</td><td style="text-align:right">${fmt(cambio)}</td></tr>` : ''}
      </table>
      <div class="hr"></div>
      <div class="c">¡Gracias por su compra!</div>
      <script>window.onload=function(){window.print();setTimeout(function(){window.close()},400)}</script>
    </body></html>`;
  const w = window.open('', '_blank', 'width=360,height=640');
  if (!w) return;
  w.document.write(html); w.document.close();
}

export default function PuntoVenta() {
  const [caja, setCaja] = useState(undefined); // undefined=cargando, {abierta,...}
  const [empresa, setEmpresa] = useState(null);
  const [flash, setFlash] = useState(null);
  const aviso = (ok, t) => { setFlash({ ok, t }); setTimeout(() => setFlash(null), 4000); };
  const cargar = () => posCaja().then(r => setCaja(r.data)).catch(() => setCaja({ abierta: false }));
  useEffect(() => { cargar(); getConfiguracion().then(r => setEmpresa(r.data)).catch(() => {}); }, []);

  if (caja === undefined) return <div style={{ padding: 40, color: '#94a3b8' }}>Cargando caja…</div>;

  return (
    <div style={{ width: '100%' }} data-pos="v2.5">
      {flash && <div style={{ ...s.flash, background: flash.ok ? '#064e3b' : '#3f1d1d', color: flash.ok ? '#6ee7b7' : '#fca5a5' }}>{flash.t}</div>}
      {!caja.abierta
        ? <AbrirCaja onAbrir={(base) => posAbrirCaja({ base_inicial: base }).then(cargar).catch(e => aviso(false, e.response?.data?.error || 'No se pudo abrir'))} />
        : <Venta caja={caja} empresa={empresa} onVenta={aviso} onRecargar={cargar} onCerrar={cargar} />}
    </div>
  );
}

function AbrirCaja({ onAbrir }) {
  const [base, setBase] = useState('');
  return (
    <div style={{ ...s.card, maxWidth: 420, margin: '40px auto', textAlign: 'center' }}>
      <h2 style={s.h1}>Abrir caja</h2>
      <p style={s.sub}>Ingresa la base inicial de efectivo para empezar a vender.</p>
      <input type="number" autoFocus style={{ ...s.in, textAlign: 'center', fontSize: 22, margin: '14px 0' }}
        placeholder="0" value={base} onChange={e => setBase(e.target.value)} />
      <button style={{ ...s.btnPrimary, width: '100%' }} onClick={() => onAbrir(Number(base) || 0)}>Abrir caja</button>
    </div>
  );
}

function Venta({ caja, empresa, onVenta, onRecargar, onCerrar }) {
  const { user } = useAuth();
  const esSupervisor = user?.rol === 'administrador' || user?.es_super_admin;
  const [carrito, setCarrito] = useState([]);
  const [busq, setBusq] = useState('');
  const [resultados, setResultados] = useState([]);
  const [formas, setFormas] = useState([]);
  const [formaSel, setFormaSel] = useState(null);
  const [incluyeIva, setIncluyeIva] = useState(false); // ajuste: precios ya incluyen IVA
  const [cajeroEdita, setCajeroEdita] = useState(false); // ajuste: cajero edita cantidades sin PIN
  const [supervisorOk, setSupervisorOk] = useState(false); // un supervisor autorizó con PIN esta venta
  const [pinOpen, setPinOpen] = useState(false);
  const [tipoDoc, setTipoDoc] = useState('fe');
  const [cobrando, setCobrando] = useState(false);
  const [cerrar, setCerrar] = useState(false);
  const [qrOpen, setQrOpen] = useState(false);
  const [recibido, setRecibido] = useState(''); // efectivo recibido (teclado numérico)
  const [qtyEdit, setQtyEdit] = useState(null); // índice de la línea cuya cantidad edita el teclado (null = Recibido)
  const [qtyFresh, setQtyFresh] = useState(false); // primer dígito reemplaza la cantidad
  const [cliente, setCliente] = useState(null); // null = Consumidor Final
  const [clienteOpen, setClienteOpen] = useState(false);
  const buscarRef = useRef(null);

  useEffect(() => { posFormas().then(r => { const list = r.data || []; setFormas(list); setFormaSel(prev => prev || formaDefault(list)); }).catch(() => {}); }, []);
  useEffect(() => { posConfig().then(r => { setIncluyeIva(!!r.data.precios_incluyen_iva); setCajeroEdita(!!r.data.cajero_edita_cantidad); }).catch(() => {}); }, []);

  useEffect(() => {
    const q = busq.trim();
    if (q.length < 2) { setResultados([]); return; }
    const t = setTimeout(() => getProductos(q).then(r => setResultados((r.data || []).slice(0, 8))).catch(() => setResultados([])), 200);
    return () => clearTimeout(t);
  }, [busq]);

  const agregar = (p) => {
    setCarrito(c => {
      const i = c.findIndex(x => x.producto_id === p.id);
      if (i >= 0) { const n = [...c]; n[i] = { ...n[i], cantidad: Number(n[i].cantidad) + 1 }; return n; }
      return [...c, { producto_id: p.id, descripcion: p.nombre, cantidad: 1, precio_unitario: Number(p.precio_unitario) || 0, iva_pct: Number(p.iva_pct) ?? 19, unidad: p.unidad || 'und', descuento_pct: 0 }];
    });
    setBusq(''); setResultados([]); buscarRef.current?.focus();
  };
  const setLinea = (i, patch) => setCarrito(c => c.map((x, j) => j === i ? { ...x, ...patch } : x));
  const quitar = (i) => { setCarrito(c => c.filter((_, j) => j !== i)); setQtyEdit(null); };
  const lt = (it) => lineaTotal(it, incluyeIva);
  const total = carrito.reduce((s, it) => s + lt(it), 0);
  const puedeEditar = esSupervisor || cajeroEdita || supervisorOk; // ¿puede cambiar cantidad/descuento/anular?
  const medio = formaSel?.tipo || 'efectivo';
  const rec = Number(recibido) || 0;
  const cambio = rec - total;
  const faltaEfectivo = medio === 'efectivo' && rec < total;

  // Teclado numérico: si hay una línea seleccionada edita su cantidad; si no, el Recibido.
  const tecla = (t) => {
    if (qtyEdit != null && carrito[qtyEdit]) {
      setCarrito(c => c.map((x, j) => {
        if (j !== qtyEdit) return x;
        let v = String(x.cantidad ?? '');
        if (t === 'C') v = '';
        else if (t === '⌫') v = v.slice(0, -1);
        else v = (qtyFresh ? t : v + t).replace(/^0+(?=\d)/, '');
        return { ...x, cantidad: v };
      }));
      setQtyFresh(false);
      return;
    }
    setRecibido(r => t === 'C' ? '' : t === '⌫' ? r.slice(0, -1) : (r + t).replace(/^0+(?=\d)/, ''));
  };
  const seleccionarQty = (i) => { setQtyEdit(i); setQtyFresh(true); };
  const confirmarQty = () => {
    setCarrito(c => c.map((x, j) => j === qtyEdit ? { ...x, cantidad: (Number(x.cantidad) || 0) < 1 ? 1 : Number(x.cantidad) } : x));
    setQtyEdit(null); setQtyFresh(false); buscarRef.current?.focus();
  };

  // Registra la venta (FE o recibo), imprime el tiquete y limpia el carrito.
  const finalizar = async (extra = {}) => {
    setCobrando(true);
    try {
      const { data } = await posVenta({ items: carrito, medio_pago: medio, forma_pago_id: formaSel?.id, tipo_doc: tipoDoc, cliente_id: cliente?.id, autorizado_supervisor: supervisorOk && !esSupervisor && !cajeroEdita });
      const doc = data.doc || data.factura;
      imprimirTiquete({ empresa, factura: doc, items: carrito, medio, recibido: extra.recibido, cambio: extra.cambio, incIva: incluyeIva });
      const etq = tipoDoc === 'recibo' ? 'Recibo' : tipoDoc === 'de' ? 'DEE' : 'FE';
      const vuelto = extra.cambio > 0 ? ` · Cambio ${fmt(extra.cambio)}` : '';
      onVenta(true, `✅ Venta registrada · ${etq} ${doc.numero} · ${fmt(doc.total)}${vuelto}`);
      setCarrito([]); setFormaSel(formaDefault(formas)); setRecibido(''); setQtyEdit(null); setCliente(null); setSupervisorOk(false); onRecargar();
      buscarRef.current?.focus();
      return true;
    } catch (e) { onVenta(false, '❌ ' + (e.response?.data?.error || 'No se pudo cobrar')); return false; }
    finally { setCobrando(false); }
  };

  const cobrar = async () => {
    if (!carrito.length) return;
    if (medio === 'qr') { setQrOpen(true); return; }                 // paga por QR y al confirmar finaliza
    if (medio === 'efectivo') {                                       // usa el teclado inline
      if (rec < total) return;
      await finalizar({ recibido: rec, cambio: Math.max(0, cambio) });
      return;
    }
    await finalizar();
  };

  return (
    <div>
      {/* Estado de caja + acciones → cinta superior, a la derecha de las sub-pestañas */}
      <RibbonActions>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <span style={{ color: '#6ee7b7', fontWeight: 700, fontSize: 13, whiteSpace: 'nowrap' }}>● Caja abierta</span>
          <span style={{ color: '#64748b', fontSize: 12, whiteSpace: 'nowrap' }}>Base {fmt(caja.sesion?.base_inicial)} · Vendido {fmt(caja.resumen?.total)} ({caja.resumen?.ventas || 0})</span>
          <button style={s.ribBtn} onClick={() => setCerrar(true)}>Cerrar caja</button>
        </div>
      </RibbonActions>

      <div style={s.grid}>
        {/* IZQUIERDA: factura / lista de venta */}
        <div style={{ ...s.card, display: 'flex', flexDirection: 'column', flex: '1.5 1 440px', minWidth: 320 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
            <b style={{ color: '#f1f5f9' }}>Venta <span style={{ color: '#64748b', fontSize: 12, fontWeight: 400 }}>· {carrito.length} ítems</span></b>
            <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
              <span style={{ color: tipoDoc === 'recibo' ? '#94a3b8' : '#64748b', fontSize: 11, marginRight: 2 }}>
                {tipoDoc === 'fe' ? 'Factura electrónica' : tipoDoc === 'de' ? 'Documento equivalente' : 'Recibo normal'}
              </span>
              <button title="Factura electrónica" style={tipoDoc === 'fe' ? s.chipOn : s.chipOff}
                onClick={() => setTipoDoc(d => d === 'fe' ? 'recibo' : 'fe')}>FE</button>
              <button disabled title="Documento equivalente electrónico POS (tipo 20) — requiere resolución DE-POS (próximamente)"
                style={tipoDoc === 'de' ? s.chipOn : s.chipDisabled}
                onClick={() => setTipoDoc(d => d === 'de' ? 'recibo' : 'de')}>DEE</button>
            </div>
          </div>
          <button style={s.clienteBtn} onClick={() => setClienteOpen(true)} title="Cliente de la venta (opcional)">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0 }}>
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
            </svg>
            <span style={{ flex: 1, textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: cliente ? '#e2e8f0' : '#94a3b8' }}>
              {cliente ? `${cliente.razon_social}${cliente.nit ? ' · ' + cliente.nit : ''}` : 'Consumidor Final'}
            </span>
            {cliente
              ? <span onClick={e => { e.stopPropagation(); setCliente(null); }} style={{ color: '#fca5a5', fontSize: 14, padding: '0 4px' }}>✕</span>
              : <span style={{ color: '#64748b', fontSize: 11 }}>cambiar ▾</span>}
          </button>
          <div style={{ flex: 1, overflowY: 'auto', margin: '10px 0', minHeight: 160 }}>
            {carrito.length === 0 && <div style={{ color: '#475569', textAlign: 'center', padding: '60px 24px', fontSize: 13 }}>
              <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ margin: '0 auto 12px', display: 'block', opacity: .7 }}>
                <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" /><path d="M3 6h18M16 10a4 4 0 0 1-8 0" />
              </svg>
              Busca o escanea un producto a la derecha para empezar la venta.
            </div>}
            {carrito.length > 0 && (
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '0 0 6px', color: '#475569', fontSize: 10, textTransform: 'uppercase', letterSpacing: .5 }}>
                <span style={{ flex: 1 }}>Producto</span>
                <span style={{ width: 50, textAlign: 'center' }}>Cant</span>
                <span style={{ width: 42, textAlign: 'center' }}>% Desc</span>
                <span style={{ width: 82, textAlign: 'right' }}>Total</span>
                <span style={{ width: 16 }} />
              </div>
            )}
            {carrito.map((it, i) => (
              <div key={i} style={{ ...s.cartRow, ...(qtyEdit === i ? { background: '#14263f', borderRadius: 8 } : {}) }}>
                <div style={{ flex: 1, minWidth: 0, cursor: 'pointer' }} onClick={() => puedeEditar ? seleccionarQty(i) : setPinOpen(true)}>
                  <div style={{ color: '#e2e8f0', fontSize: 13, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{it.descripcion}</div>
                  <div style={{ color: '#64748b', fontSize: 11 }}>{fmt(it.precio_unitario)}{incluyeIva ? ' (IVA incl.)' : ` · IVA ${it.iva_pct}%`}{Number(it.descuento_pct) ? ` · -${it.descuento_pct}%` : ''}</div>
                </div>
                <input type="number" readOnly={!puedeEditar} title={puedeEditar ? 'Toca para editar la cantidad con el teclado' : 'Requiere PIN de supervisor'}
                  style={{ ...s.in, width: 50, padding: '5px 4px', textAlign: 'center', border: qtyEdit === i ? '1px solid #3b82f6' : '1px solid #334155', opacity: puedeEditar ? 1 : .6, cursor: puedeEditar ? 'text' : 'pointer' }}
                  value={it.cantidad} onFocus={() => { if (puedeEditar) seleccionarQty(i); }} onClick={() => { if (!puedeEditar) setPinOpen(true); }}
                  onChange={e => { if (!puedeEditar) return; setLinea(i, { cantidad: e.target.value }); setQtyFresh(false); }} />
                <input type="number" min="0" max="100" readOnly={!puedeEditar} title={puedeEditar ? 'Descuento %' : 'Requiere PIN de supervisor'} placeholder="0"
                  style={{ ...s.in, width: 42, padding: '5px 4px', textAlign: 'center', color: Number(it.descuento_pct) ? '#fbbf24' : '#64748b', opacity: puedeEditar ? 1 : .6, cursor: puedeEditar ? 'text' : 'pointer' }}
                  value={it.descuento_pct || ''} onClick={() => { if (!puedeEditar) setPinOpen(true); }}
                  onChange={e => { if (!puedeEditar) return; setLinea(i, { descuento_pct: Math.max(0, Math.min(100, Number(e.target.value) || 0)) }); }} />
                <div style={{ width: 82, textAlign: 'right', color: '#cbd5e1', fontSize: 13 }}>{fmt(lt(it))}</div>
                <button style={s.del} title={puedeEditar ? 'Quitar' : 'Requiere PIN de supervisor'} onClick={() => puedeEditar ? quitar(i) : setPinOpen(true)}>✕</button>
              </div>
            ))}
          </div>
          <div style={{ borderTop: '1px solid #334155', paddingTop: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ color: '#94a3b8' }}>Total</span>
            <span style={{ color: '#f1f5f9', fontSize: 30, fontWeight: 800 }}>{fmt(total)}</span>
          </div>
        </div>

        {/* DERECHA: buscar (arriba) + medio de pago + teclado */}
        <div style={{ ...s.card, display: 'flex', flexDirection: 'column', flex: '0 1 360px', minWidth: 300 }}>
          <label style={s.lbl}>Producto (nombre o código de barras)</label>
          <input ref={buscarRef} autoFocus style={{ ...s.in, fontSize: 16, padding: '12px 14px' }} placeholder="Escanea o escribe…" value={busq}
            onChange={e => setBusq(e.target.value)} onFocus={() => setQtyEdit(null)}
            onKeyDown={e => { if (e.key === 'Enter' && resultados[0]) agregar(resultados[0]); }} />
          <div style={{ marginTop: 10, flex: 1, overflowY: 'auto', minHeight: 40 }}>
            {resultados.map(p => (
              <div key={p.id} style={s.resItem} onClick={() => agregar(p)}>
                <span>{p.codigo ? <b style={{ color: '#93c5fd' }}>{p.codigo}</b> : ''} {p.nombre}</span>
                <span style={{ color: '#6ee7b7' }}>{fmt(p.precio_unitario)}</span>
              </div>
            ))}
            {busq.trim().length >= 2 && resultados.length === 0 && <div style={{ color: '#64748b', fontSize: 13, padding: 8 }}>Sin coincidencias.</div>}
          </div>

          <div style={{ borderTop: '1px solid #334155', paddingTop: 10 }}>
            <div style={{ display: 'flex', gap: 6, marginBottom: 10, flexWrap: 'wrap' }}>
              {formas.map(f => (
                <button key={f.id} style={{ ...(formaSel?.id === f.id ? s.selOn : s.selOff), flex: '1 1 30%', minWidth: 70, textAlign: 'center' }} onClick={() => setFormaSel(f)}>{f.nombre}</button>
              ))}
            </div>
            {(medio === 'efectivo' || qtyEdit != null) ? <>
              <div style={s.numDisplay}>
                {qtyEdit != null ? <>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                    <span style={{ color: '#7dd3fc', fontSize: 11, fontWeight: 600 }}>Cantidad</span>
                    <span style={{ color: '#64748b', fontSize: 11, maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{carrito[qtyEdit]?.descripcion}</span>
                  </div>
                  <div style={{ color: '#f1f5f9', fontSize: 22, fontWeight: 800, textAlign: 'right', minHeight: 28 }}>{carrito[qtyEdit]?.cantidad || 0}</div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #334155', marginTop: 6, paddingTop: 6 }}>
                    <span style={{ color: '#64748b', fontSize: 11 }}>Subtotal</span>
                    <span style={{ color: '#cbd5e1', fontWeight: 700 }}>{fmt(lt(carrito[qtyEdit] || {}))}</span>
                  </div>
                </> : <>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                    <span style={{ color: '#64748b', fontSize: 11 }}>Recibido</span>
                    <button style={s.exacto} onClick={() => setRecibido(String(Math.round(total)))}>Exacto</button>
                  </div>
                  <div style={{ color: recibido ? '#f1f5f9' : '#475569', fontSize: 22, fontWeight: 800, textAlign: 'right', minHeight: 28 }}>{fmt(rec)}</div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #334155', marginTop: 6, paddingTop: 6 }}>
                    <span style={{ color: '#64748b', fontSize: 11 }}>Cambio</span>
                    <span style={{ fontWeight: 800, color: !recibido ? '#64748b' : faltaEfectivo ? '#fca5a5' : '#6ee7b7' }}>
                      {!recibido ? fmt(0) : faltaEfectivo ? 'Falta ' + fmt(total - rec) : fmt(cambio)}
                    </span>
                  </div>
                </>}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 6, marginTop: 8 }}>
                <button style={s.numKey} onClick={() => tecla('7')}>7</button>
                <button style={s.numKey} onClick={() => tecla('8')}>8</button>
                <button style={s.numKey} onClick={() => tecla('9')}>9</button>
                <button style={s.numAlt} title="Borrar" onClick={() => tecla('⌫')}>⌫</button>
                <button style={s.numKey} onClick={() => tecla('4')}>4</button>
                <button style={s.numKey} onClick={() => tecla('5')}>5</button>
                <button style={s.numKey} onClick={() => tecla('6')}>6</button>
                <button style={s.numAlt} title="Limpiar" onClick={() => tecla('C')}>C</button>
                <button style={s.numKey} onClick={() => tecla('1')}>1</button>
                <button style={s.numKey} onClick={() => tecla('2')}>2</button>
                <button style={s.numKey} onClick={() => tecla('3')}>3</button>
                <button style={{ ...s.numEnter, gridColumn: 4, gridRow: '3 / 5', opacity: (qtyEdit == null && (cobrando || !carrito.length || faltaEfectivo)) ? .45 : 1 }}
                  disabled={qtyEdit == null && (cobrando || !carrito.length || faltaEfectivo)}
                  title={qtyEdit != null ? 'Confirmar cantidad' : 'Cobrar (Enter)'}
                  onClick={qtyEdit != null ? confirmarQty : cobrar}>
                  {cobrando ? '…' : <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path d="M20 6L9 17l-5-5" /></svg>}
                </button>
                <button style={{ ...s.numKey, gridColumn: '1 / 4' }} onClick={() => tecla('0')}>0</button>
              </div>
            </> : <>
              <div style={{ ...s.numDisplay, textAlign: 'center', color: '#64748b', fontSize: 12, lineHeight: 1.5, padding: '18px 12px' }}>
                {medio === 'qr' ? 'El QR Bre-B se genera al cobrar.'
                  : medio === 'tarjeta' ? 'Pago con tarjeta (datáfono). No requiere monto aquí.'
                    : `${formaSel?.nombre || 'Pago'}: presiona el botón verde para cobrar.`}
              </div>
              <button style={{ ...s.numEnter, width: '100%', padding: '14px', marginTop: 8, fontSize: 16, opacity: (cobrando || !carrito.length) ? .45 : 1 }}
                disabled={cobrando || !carrito.length} onClick={cobrar}>
                {cobrando ? 'Cobrando…' : `Cobrar ${fmt(total)}`}
              </button>
            </>}
          </div>
        </div>
      </div>

      {pinOpen && <PinSupervisor onClose={() => setPinOpen(false)} onOk={() => { setSupervisorOk(true); setPinOpen(false); onVenta(true, 'Supervisor autorizó cambios en esta venta'); }} aviso={onVenta} />}
      {clienteOpen && <ClientePicker onClose={() => setClienteOpen(false)}
        onElegir={(c) => { setCliente(c); setClienteOpen(false); }}
        onConsumidorFinal={() => { setCliente(null); setClienteOpen(false); }} />}
      {cerrar && <CerrarCaja onClose={() => setCerrar(false)} onCerrado={() => { setCerrar(false); onCerrar(); }} aviso={onVenta} />}
      {qrOpen && <CobroQR total={total} onClose={() => setQrOpen(false)}
        onPagado={async () => { const ok = await finalizar(); setQrOpen(false); return ok; }}
        onNeedsConfig={() => { setQrOpen(false); onVenta(false, 'Configura la clave de SnelPay en Sistema → Configuración POS'); }} />}
    </div>
  );
}

// Muestra el QR Bre-B de SnelPay y consulta el pago hasta confirmarlo.
function CobroQR({ total, onClose, onPagado, onNeedsConfig }) {
  const [cobro, setCobro] = useState(null); // {cobro_id, qr_img}
  const [estado, setEstado] = useState('creando'); // creando|pendiente|pagado|error
  const [msg, setMsg] = useState('');

  useEffect(() => {
    let vivo = true, timer;
    posCobroQR({ total }).then(({ data }) => {
      if (!vivo) return;
      setCobro(data); setEstado('pendiente');
      const poll = () => posCobroQREstado(data.cobro_id).then(({ data: s }) => {
        if (!vivo) return;
        if (s.pagado) { setEstado('pagado'); onPagado(); }
        else timer = setTimeout(poll, 3000);
      }).catch(() => { if (vivo) timer = setTimeout(poll, 4000); });
      timer = setTimeout(poll, 3000);
    }).catch((e) => {
      if (!vivo) return;
      if (e.response?.status === 503) { onNeedsConfig(); return; }
      setEstado('error'); setMsg(e.response?.data?.error || 'No se pudo generar el QR');
    });
    return () => { vivo = false; clearTimeout(timer); };
  }, [total]); // eslint-disable-line

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={{ ...s.card, width: 360, textAlign: 'center' }} onClick={e => e.stopPropagation()}>
        <h3 style={s.h1}>Cobro por QR · Bre-B</h3>
        <p style={s.sub}>El cliente escanea el código con su app bancaria.</p>
        <div style={{ margin: '16px auto', width: 240, height: 240, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', borderRadius: 12 }}>
          {cobro?.qr_img
            ? <img src={cobro.qr_img} alt="QR de pago" style={{ width: 224, height: 224 }} />
            : <span style={{ color: '#0f172a', fontSize: 13 }}>{estado === 'error' ? 'Sin QR' : 'Generando…'}</span>}
        </div>
        <div style={{ fontSize: 22, fontWeight: 800, color: '#f1f5f9' }}>{fmt(total)}</div>
        {estado === 'pendiente' && <div style={{ color: '#fbbf24', fontSize: 13, marginTop: 8 }}>Esperando el pago…</div>}
        {estado === 'pagado' && <div style={{ color: '#6ee7b7', fontSize: 14, marginTop: 8, fontWeight: 600 }}>Pago recibido</div>}
        {estado === 'error' && <div style={{ color: '#fca5a5', fontSize: 13, marginTop: 8 }}>{msg}</div>}
        <button style={{ ...s.btnGhost, width: '100%', marginTop: 16 }} onClick={onClose}>Cancelar</button>
      </div>
    </div>
  );
}

// Selector de cliente para la venta: buscar existente, crear rápido o Consumidor Final.
// Pide el PIN del supervisor para autorizar cambios sensibles sin cambiar de sesión.
function PinSupervisor({ onClose, onOk }) {
  const [pin, setPin] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const verificar = async () => {
    if (!pin) return;
    setBusy(true); setErr('');
    try { await posVerificarPin(pin); onOk(); }
    catch (e) {
      setErr(e.response?.status === 409 ? 'No hay PIN configurado. Ve a Sistema → Configuración POS.' : (e.response?.data?.error || 'PIN incorrecto'));
      setBusy(false);
    }
  };
  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={{ ...s.card, width: 340, textAlign: 'center' }} onClick={e => e.stopPropagation()}>
        <h3 style={s.h1}>Autorización de supervisor</h3>
        <p style={s.sub}>Ingresa el PIN para editar cantidades, descuentos o anular una línea.</p>
        <input type="password" inputMode="numeric" autoFocus maxLength={6}
          style={{ ...s.in, textAlign: 'center', letterSpacing: 6, fontSize: 22, margin: '14px 0' }}
          value={pin} onChange={e => { setPin(e.target.value.replace(/\D/g, '')); setErr(''); }} onKeyDown={e => { if (e.key === 'Enter') verificar(); }} />
        {err && <div style={{ color: '#fca5a5', fontSize: 12, marginBottom: 10 }}>{err}</div>}
        <div style={{ display: 'flex', gap: 10 }}>
          <button style={s.btnGhost} onClick={onClose}>Cancelar</button>
          <button style={{ ...s.btnPrimary, flex: 1 }} disabled={busy || !pin} onClick={verificar}>{busy ? 'Verificando…' : 'Autorizar'}</button>
        </div>
      </div>
    </div>
  );
}

function ClientePicker({ onClose, onElegir, onConsumidorFinal }) {
  const [q, setQ] = useState('');
  const [resultados, setResultados] = useState([]);
  const [crear, setCrear] = useState(false);

  useEffect(() => {
    const s = q.trim();
    if (s.length < 2) { setResultados([]); return; }
    const t = setTimeout(() => posBuscarClientes(s).then(r => setResultados(r.data || [])).catch(() => setResultados([])), 250);
    return () => clearTimeout(t);
  }, [q]);

  // El alta usa el MISMO modal completo del módulo Clientes (ClienteModal).
  if (crear) return <ClienteModal inicial={{ razon_social: q.trim() }} onClose={() => setCrear(false)} onCreated={onElegir} />;

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={{ ...s.card, width: 440 }} onClick={e => e.stopPropagation()}>
        <h3 style={s.h1}>Cliente de la venta</h3>
        <p style={s.sub}>Busca por nombre o NIT/cédula. Si no eliges ninguno, la venta sale a <b style={{ color: '#cbd5e1' }}>Consumidor Final</b>.</p>
        <input autoFocus style={{ ...s.in, margin: '12px 0' }} placeholder="Nombre o NIT/cédula…" value={q} onChange={e => setQ(e.target.value)} />
        <div style={{ maxHeight: '34vh', overflowY: 'auto', marginBottom: 10 }}>
          {resultados.map(c => (
            <div key={c.id} style={s.resItem} onClick={() => onElegir(c)}>
              <span style={{ color: '#e2e8f0' }}>{c.razon_social}</span>
              <span style={{ color: '#64748b', fontSize: 12 }}>{c.nit || ''}</span>
            </div>
          ))}
          {q.trim().length >= 2 && resultados.length === 0 && <div style={{ color: '#64748b', fontSize: 13, padding: 8 }}>Sin coincidencias.</div>}
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button style={s.btnGhost} onClick={onConsumidorFinal}>Consumidor Final</button>
          <button style={{ ...s.btnPrimary, flex: 1 }} onClick={() => setCrear(true)}>+ Crear cliente</button>
        </div>
      </div>
    </div>
  );
}

function CerrarCaja({ onClose, onCerrado, aviso }) {
  const [contado, setContado] = useState('');
  const [resumen, setResumen] = useState(null);
  const [busy, setBusy] = useState(false);
  const cerrar = async () => {
    setBusy(true);
    try { const { data } = await posCerrarCaja({ efectivo_contado: Number(contado) || 0 }); setResumen(data.resumen); }
    catch (e) { aviso(false, '❌ ' + (e.response?.data?.error || 'No se pudo cerrar')); setBusy(false); }
  };
  return (
    <div style={s.overlay} onClick={resumen ? onCerrado : onClose}>
      <div style={{ ...s.card, width: 420 }} onClick={e => e.stopPropagation()}>
        <h3 style={s.h1}>Cierre de caja (arqueo)</h3>
        {!resumen ? <>
          <p style={s.sub}>Cuenta el efectivo en caja y escribe el total.</p>
          <input type="number" autoFocus style={{ ...s.in, fontSize: 20, textAlign: 'center', margin: '12px 0' }} placeholder="Efectivo contado" value={contado} onChange={e => setContado(e.target.value)} />
          <div style={{ display: 'flex', gap: 10 }}>
            <button style={s.btnGhost} onClick={onClose}>Cancelar</button>
            <button style={{ ...s.btnPrimary, flex: 1 }} disabled={busy} onClick={cerrar}>{busy ? 'Cerrando…' : 'Cerrar caja'}</button>
          </div>
        </> : <>
          <div style={{ fontSize: 13, color: '#cbd5e1' }}>
            {[['Base inicial', resumen.base_inicial], ['Ventas', `${resumen.ventas} · ${fmt(resumen.total)}`], ['Efectivo', fmt(resumen.efectivo)], ['Tarjeta', fmt(resumen.tarjeta)], ['Otro', fmt(resumen.otro)], ['Efectivo esperado', fmt(resumen.efectivo_esperado)], ['Efectivo contado', fmt(resumen.efectivo_contado)]].map(([k, v]) => (
              <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: '1px solid #1e293b' }}><span style={{ color: '#94a3b8' }}>{k}</span><span>{typeof v === 'number' ? fmt(v) : v}</span></div>
            ))}
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0 0', fontWeight: 700, color: resumen.diferencia === 0 ? '#6ee7b7' : '#fca5a5' }}>
              <span>Diferencia</span><span>{fmt(resumen.diferencia)}{resumen.diferencia === 0 ? ' (cuadrada)' : ''}</span>
            </div>
          </div>
          <button style={{ ...s.btnPrimary, width: '100%', marginTop: 14 }} onClick={onCerrado}>Listo</button>
        </>}
      </div>
    </div>
  );
}

const s = {
  h1: { color: '#f1f5f9', fontSize: 18, fontWeight: 700, margin: '0 0 4px' },
  sub: { color: '#64748b', fontSize: 13, margin: 0 },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 18 },
  in: { width: '100%', boxSizing: 'border-box', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '9px 11px', color: '#f1f5f9', fontSize: 14 },
  lbl: { display: 'block', color: '#94a3b8', fontSize: 12, marginBottom: 6 },
  btnPrimary: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 10, padding: '11px 18px', fontSize: 14, fontWeight: 700, cursor: 'pointer' },
  btnGhost: { background: 'transparent', color: '#94a3b8', border: '1px solid #334155', borderRadius: 8, padding: '9px 16px', fontSize: 13, cursor: 'pointer' },
  topbar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#1e293b', border: '1px solid #334155', borderRadius: 10, padding: '10px 16px', marginBottom: 14, flexWrap: 'wrap', gap: 10 },
  grid: { display: 'flex', gap: 16, alignItems: 'stretch', flexWrap: 'wrap', minHeight: 'calc(100vh - 220px)' },
  resItem: { display: 'flex', justifyContent: 'space-between', gap: 10, padding: '9px 11px', borderRadius: 8, cursor: 'pointer', fontSize: 13, color: '#cbd5e1', borderBottom: '1px solid #16202e' },
  cartRow: { display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0', borderBottom: '1px solid #16202e' },
  del: { background: 'none', border: 'none', color: '#fca5a5', cursor: 'pointer', fontSize: 14 },
  payOn: { flex: 1, background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '9px', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  payOff: { flex: 1, background: '#0f172a', color: '#94a3b8', border: '1px solid #334155', borderRadius: 8, padding: '9px', fontSize: 13, cursor: 'pointer' },
  payDisabled: { flex: 1, background: '#0f172a', color: '#475569', border: '1px dashed #334155', borderRadius: 8, padding: '9px', fontSize: 13, cursor: 'not-allowed' },
  miniLbl: { color: '#64748b', fontSize: 11, marginBottom: 5 },
  clienteBtn: { display: 'flex', alignItems: 'center', gap: 8, width: '100%', marginTop: 10, background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 10px', color: '#94a3b8', fontSize: 13, cursor: 'pointer' },
  selOn: { width: '100%', textAlign: 'left', background: '#1d4ed8', color: '#fff', border: '1px solid #3b82f6', borderRadius: 8, padding: '8px 10px', fontSize: 12.5, fontWeight: 600, cursor: 'pointer' },
  selOff: { width: '100%', textAlign: 'left', background: '#0f172a', color: '#94a3b8', border: '1px solid #334155', borderRadius: 8, padding: '8px 10px', fontSize: 12.5, cursor: 'pointer' },
  selDisabled: { width: '100%', textAlign: 'left', background: '#0f172a', color: '#475569', border: '1px dashed #334155', borderRadius: 8, padding: '8px 10px', fontSize: 12.5, cursor: 'not-allowed' },
  numDisplay: { background: '#0f172a', border: '1px solid #334155', borderRadius: 10, padding: '8px 10px' },
  exacto: { background: 'transparent', border: 'none', color: '#7dd3fc', fontSize: 11, fontWeight: 600, cursor: 'pointer', padding: 0 },
  numKey: { background: '#1e293b', color: '#e2e8f0', border: '1px solid #334155', borderRadius: 8, padding: '12px 0', fontSize: 18, fontWeight: 600, cursor: 'pointer' },
  numAlt: { background: '#0f172a', color: '#94a3b8', border: '1px solid #334155', borderRadius: 8, padding: '12px 0', fontSize: 18, cursor: 'pointer' },
  numEnter: { background: '#16a34a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  ribBtn: { background: 'transparent', color: '#94a3b8', border: '1px solid #334155', borderRadius: 7, padding: '5px 10px', fontSize: 12, cursor: 'pointer', whiteSpace: 'nowrap' },
  chipOn: { background: '#1d4ed8', color: '#fff', border: '1px solid #3b82f6', borderRadius: 7, padding: '5px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' },
  chipOff: { background: '#0f172a', color: '#94a3b8', border: '1px solid #334155', borderRadius: 7, padding: '5px 10px', fontSize: 12, cursor: 'pointer', whiteSpace: 'nowrap' },
  chipDisabled: { background: '#0f172a', color: '#475569', border: '1px dashed #334155', borderRadius: 7, padding: '5px 10px', fontSize: 12, cursor: 'not-allowed', whiteSpace: 'nowrap' },
  flash: { padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 12 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
};
